import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=1c648581&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"
import style0 from "./Logs.vue?vue&type=style&index=0&id=1c648581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c648581",
  null
  
)

export default component.exports